module.exports = __webpack_public_path__ + "img/十门控制器 (1).63380176.jpg";